import { useEffect, useRef, useState } from "react";
import boutimeLogo from "../assets/bouttime-logo.svg";

export default function SplashScreen({ onComplete }) {
  const [fadingOut, setFadingOut] = useState(false);
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  });

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadingOut(true), 2000);
    const doneTimer = setTimeout(() => onCompleteRef.current?.(), 2500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, []);

  return (
    <>
      <style>{`
        @keyframes splashLogoIn {
          from { opacity: 0; transform: scale(0.94); }
          to   { opacity: 1; transform: scale(1); }
        }
        @keyframes splashAppear {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "linear-gradient(180deg, #FAF3E8 0%, #F2E8D5 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          opacity: fadingOut ? 0 : 1,
          transition: "opacity 0.5s ease",
          pointerEvents: fadingOut ? "none" : "auto",
        }}
      >
        <img
          src={boutimeLogo}
          alt="Bout Time"
          style={{
            width: 160,
            animation: "splashLogoIn 0.5s ease forwards",
          }}
        />
      </div>
    </>
  );
}
